import React, { useState, useMemo, useEffect } from "react";
// react plugin used to create DropdownMenu for selecting items
import Select, { components } from 'react-select';
import './SelectTeachers.css'

const Option = (props) => {
      return (
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null } // Handled by react-select's built-in onChange
          />{' '}
          <label>{props.label}</label>
        </components.Option>
      );
    };

const SelectTeachers = (props) => {
  const [value, setValue] = useState()
  const [options, setOptions] = useState([])
  const group = props.group
  const setGroup = props.setGroup

  const changeHandler = items => {
    setValue(items)
    let users = []
    items?.map(item => {users.push(item.value)})
    group['users'] = users
    setGroup(group)
  }

  useEffect(() => {

    let alternatives = []
    let selected = []

    props.selectOptions?.map((item) => {
      let target = { value: item.user._id, label: item.user.name }

      alternatives.push(target)

      //carrega Teachers selecionados para telas de consulta
      //se for o caso
      if (group?.users?.includes(item.user._id)){
        selected.push(target)        
      }

    })

    setOptions(alternatives)  
    setValue(selected)  

  }, [props.selectOptions])

  return (    
    <div >
      <Select
        isMulti
        components={{ Option }}
        className="form-control-alternative"
        isDisabled={props.formDisabled}
        options={options}
        value={value}
        id="input-app"
        classNamePrefix="selectTeachers"
        onChange={changeHandler}
      />
    </div>
  );

}

export default SelectTeachers;
